<template>
  <page-outline :title="$t('Webheader.import_bank_account')"
    iconF7="list_bullet">
    <template slot="pageContent">
      <div class="form-group row">
        <label class="col-5 col-sm-2">
          <div class="fileContainer">
            Choose file
            <input ref="fileInput" type="file" name="file2" id="file2" @change="onFileChange"></input>
          </div>
        </label>
        <div class="col-7 col-sm-10">
          <input class="form-control" name="filename" placeholder="Choose file" type="text" v-model="attachmentName" disabled></input>
        </div>
      </div>
    </template>
    <template slot="footerButtons">
      <b-row>
        <b-col md="2" offset-md="9">
          <f7-button class="button-action milkyBlockBlack"
            @click="importAttachment">
            <f7-icon f7="list_bullet"></f7-icon>
            <span>Import</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'importAttachement',
  components: {
    // 'cm-bank-import-report-list': BankAccountsImportReportList,
    'page-outline': PageOutline
  },
  data () {
    return {
      mimeType: '',
      attachment: '',
      attachmentName: '',
      report: [],
      isSmartphone: false
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.mimeType = ''
    this.attachment = ''
    this.attachmentName = ''
    // this.$refs.fileInput.value = null
  },
  methods: {
    importAttachment () {
      let that = this
      if (that.attachment !== '' && that.attachmentName !== '') {
        var lines = that.attachment.split('\n')
        for (var i = 0; i < lines.length; i++) {
          if (i > 0) {
            var csvs = lines[i].split(';')
            if (csvs.length > 1) {
              if (csvs.length === 15) {
                that.addAccount(csvs[0], csvs[10] + csvs[11] + csvs[3], csvs[9], i + 1)
              } else {
                // that.report += 'Line ' + (i + 1) + ': ' + csvs[0] + ' invalid value number\n'
                var objReport3 = {line: i + 1, name: csvs[0], iban: csvs[10] + csvs[11] + csvs[3], status: 0, description: 'invalid value number'}
                that.report.push(objReport3)
              }
            }
          }
        }
        this.mimeType = ''
        this.attachment = ''
        this.attachmentName = ''
        this.$engine.bankAccounts.setImportReport(that.report)
        this.$bus.emit('refresh-bank-accounts-import-report')
        loadPage(that, {url: '/bankAccounts/importReport/', force: false, ignoreCache: false})
      } else {
        that.$f7.alert('', 'Data missing')
      }
    },
    addAccount (name, iban, zone, line) {
      var error = ''
      // Create account
      this.$engine.bankAccounts
        .create({
          name: name,
          iban: iban,
          zoneCode: zone
        })
        .then(resp => {
          var objReport = {line: line, name: name, iban: iban, status: 1, description: 'Added'}
          this.report.push(objReport)
          // that.$bus.$emit('refresh-cache-bank-accounts')
          /* this.$f7.modal({
            title: 'Adding account',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
          }, 2000) */
        })
        .catch(err => {
          var objReport = {line: line, name: name, iban: iban, status: 0, description: err.response.statusText}
          this.report.push(objReport)
          // errorMessageAlert(err, that)
        })
      return error
    },
    onFileChange (e) {
      /* eslint-disable no-undef */
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 1000000) {
        that.createImage(files[0])
        that.attachmentName = files[0].name
        that.mimeType = files[0].type
      } else {
        that.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 1MB', 'Maximum file size exceeded')
      }
    },
    createImage (file) {
      let reader = new FileReader()
      let that = this
      this.$f7.modal({
        title: 'Charging File',
        text: '<span class="preloader"></span>'
      })
      reader.onload = (e) => {
        that.attachment = e.target.result
        that.$f7.closeModal()
      }
      reader.readAsBinaryString(file)
    }
  }
}
</script>
<style scoped>
.fileContainer [type=file] {
    display: none;
    color: white;
}
.fileContainer {
  border: 1px solid #ffd210;
  text-decoration: none;
  text-align: center;
  border-radius: 27px;
  line-height: 25px;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  padding: 0 10px;
  margin: 0;
  height: 27px;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  outline: 0;
  width: auto;
  float: right;
}
.attachmentImportButtonLength {
  width: 101px;
}
.progressbar {
  height: 8px;
}
/*
.col-md-offset-3 {
    margin-left: 25%;
    margin-top: 2%;

}*/
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 90%
}

.button.button-round {
    border-radius: 27px;
    margin: auto;
}
.panel-heading {
    padding: 10px 15px;
    border-bottom: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// CMImportBankAccount.vue?b9e8d8b8